var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3.75V8.5c0 .41.34.75.75.75s.75-.34.75-.75V3.75H14c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-4c-.41 0-.75.34-.75.75s.34.75.75.75h1.25zM12.75 20.25V15.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v4.75H10c-.41 0-.75.34-.75.75s.34.75.75.75h4c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-1.25zM3.2 9.979c.26 0 .51-.13.65-.38l.63-1.08 4.12 2.38c.11.07.24.1.37.1.26 0 .51-.13.65-.38.21-.35.08-.81-.27-1.02l-4.12-2.38.62-1.08c.21-.36.08-.82-.27-1.02a.738.738 0 0 0-1.02.27l-2 3.46a.75.75 0 0 0 .64 1.13zM20.148 14.391l-.63 1.08-4.12-2.37a.746.746 0 0 0-.75 1.29l4.11 2.38-.62 1.08a.746.746 0 0 0 .64 1.12c.26 0 .51-.13.65-.38l2-3.46c.22-.35.1-.8-.26-1.01a.738.738 0 0 0-1.02.27zM14.65 9.6c-.36.21-.48.67-.27 1.02.14.24.39.38.65.38.13 0 .26-.03.37-.1l4.11-2.38.63 1.08c.14.24.39.38.65.38.13 0 .26-.03.37-.1.36-.21.48-.67.27-1.02l-2-3.46a.742.742 0 0 0-1.02-.27c-.36.21-.48.67-.27 1.02l.63 1.07-4.12 2.38zM9.34 14.401c.36-.21.48-.67.27-1.02a.742.742 0 0 0-1.02-.27l-4.11 2.38-.63-1.08a.742.742 0 0 0-1.02-.27c-.36.21-.48.67-.27 1.02l2 3.46c.14.24.39.38.65.38.13 0 .26-.03.37-.1.36-.21.48-.67.27-1.02l-.62-1.1 4.11-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.03 13.75A3.5 3.5 0 0 1 12 15.5a3.5 3.5 0 0 1 0-7 3.5 3.5 0 0 1 3.03 5.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSun);
export default __webpack_public_path__ + "static/media/vuesax-bold-sun.e76d5b51a5baee40209bd3de7ca5fbd4.svg";
export { ForwardRef as ReactComponent };